import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import { HttpService } from 'src/app/services/http/http.service';
import { Router } from '@angular/router';
import { BasePageComponent } from 'src/app/pages/base-page';
import { ForgotPssService } from '../forgot-form/forgot-form.service';
import Swal from 'sweetalert2'
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'forgot-form',
  templateUrl: './forgot-form.component.html',
  styleUrls: ['./forgot-form.component.scss']
})
export class ForgotFormComponent extends BasePageComponent implements OnInit, OnDestroy {
  errorMessage
  forgotForm: FormGroup;
  forgotLoginForm: boolean;

  constructor(private fb: FormBuilder,private forgotPssService: ForgotPssService, private router:Router,
    store: Store<IAppState>,
    httpSv: HttpService) { 
    super(store, httpSv);
  }

  ngOnInit() {
    // sessionStorage.clear();
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required,Validators.email]],
    });
  }

  forgotFormSubmit(){
    this.forgotLoginForm = true;
    if(this.forgotForm.invalid){
      return;
    }
    this.forgotPssService.postLogin(this.forgotForm.value).subscribe(
      response => {
        if(response['status'] == true){
          Swal.fire("Please check your email")
          this.forgotLoginForm = false;
        }
        else{
          Swal.fire(response.message)
          this.forgotLoginForm = false;
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        Swal.fire(this.errorMessage);
        this.forgotLoginForm = false;
    }
    )
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
